import { FC } from "react";

import { TextInput as CascadifyTextInput, ITextInputProps } from "@dzambalaorg/mui-inputs-core";

import { TextInputWrapper } from "./styled";

export const TextInput: FC<ITextInputProps> = props => {
  return (
    <TextInputWrapper>
      <CascadifyTextInput variant="outlined" {...props} />
    </TextInputWrapper>
  );
};
